
import React from 'react';
import { HubSpotFormEmbed } from './HubSpotFormEmbed';

interface ConsultationFormProps {
  formId?: string;
  onSubmitted?: () => void;
  calculationResult?: number | null;
  industryType?: string;
}

export const ConsultationForm = ({ 
  formId = "1696a603-03f3-486d-aed9-36414a01ba23",
  onSubmitted,
  calculationResult,
  industryType
}: ConsultationFormProps) => {
  // Prepare any hidden fields that should be passed to HubSpot
  const hiddenFields: Record<string, string> = {};
  
  if (calculationResult !== undefined && calculationResult !== null) {
    hiddenFields.calculated_value = calculationResult.toString();
  }
  
  if (industryType) {
    hiddenFields.industry = industryType;
  }

  return (
    <div className="consultation-form bg-white rounded-md">
      <HubSpotFormEmbed
        formId={formId}
        onFormSubmitted={onSubmitted}
        hiddenFields={hiddenFields}
        className="w-full"
      />
    </div>
  );
};
